import catalog from "./blogCatalog.json";

export const SHARED_BLOG_SLUGS = catalog.shared;
export const RU_ONLY_BLOG_SLUGS = catalog.ruOnly;
export const LANGUAGE_ONLY_BLOG_SLUGS = catalog.languageOnly;

const exclusiveLanguageBySlug = new Map([
  ...RU_ONLY_BLOG_SLUGS.map((slug) => [slug, "ru"]),
  ...Object.entries(LANGUAGE_ONLY_BLOG_SLUGS).flatMap(([language, slugs]) =>
    slugs.map((slug) => [slug, language])
  ),
]);

export const getExclusiveBlogLanguage = (slug) =>
  exclusiveLanguageBySlug.get(slug) || null;

export const getBlogSlugs = (language) => {
  if (language === "ru") {
    return [...RU_ONLY_BLOG_SLUGS, ...SHARED_BLOG_SLUGS];
  }

  return [
    ...(LANGUAGE_ONLY_BLOG_SLUGS[language] || []),
    ...SHARED_BLOG_SLUGS,
  ];
};
